<div class="container mt-4">
  <div class="d-flex flex-wrap justify-content-between align-items-center mb-4">
    <h2 class="mb-2">COMPTES UTILISATEURS</h2>
    <button type="button" class="btn btn-primary mb-2" (click)="openCreate()">
      <i class="fa fa-user-plus"></i> Nouveau compte
    </button>
  </div>

  <div class="bg-light p-3 mb-3 rounded d-flex flex-wrap align-items-center accounts-filters">
    <input type="search" class="form-control accounts-search" placeholder="Rechercher par nom ou email"
           [(ngModel)]="search" (ngModelChange)="onSearchChange()">
    <div class="form-check ml-md-3">
      <input class="form-check-input" type="checkbox" id="includeStudents" [(ngModel)]="includeStudents" (change)="load()">
      <label class="form-check-label" for="includeStudents">Afficher les élèves</label>
    </div>
    <div class="form-check ml-md-3">
      <input class="form-check-input" type="checkbox" id="includeDisabled" [(ngModel)]="includeDisabled">
      <label class="form-check-label" for="includeDisabled">Afficher les comptes désactivés ({{ disabledCount }})</label>
    </div>
  </div>

  <div class="alert alert-danger" *ngIf="messageError">{{ messageError }}</div>
  <div class="text-muted" *ngIf="loading"><i class="fa fa-spinner fa-spin"></i> Chargement...</div>

  <div class="table-responsive" *ngIf="!loading">
    <table class="table table-hover">
      <thead class="thead-light">
      <tr>
        <th>Utilisateur</th>
        <th>Email</th>
        <th>Type</th>
        <th>Rôles</th>
        <th class="text-right">Actions</th>
      </tr>
      </thead>
      <tbody>
      <tr *ngIf="displayedAccounts.length === 0">
        <td colspan="5" class="text-muted">Aucun compte trouvé.</td>
      </tr>
      <tr *ngFor="let a of displayedAccounts" [class.account-row--disabled]="!a.enabled">
        <td class="font-weight-bold">{{ a.username }}</td>
        <td>{{ a.email }}</td>
        <td>
          <span class="account-type" [ngClass]="'account-type--' + a.type.toLowerCase()">{{ typeLabel(a) }}</span>
          <span class="account-type account-type--disabled ml-1" *ngIf="!a.enabled">Désactivé</span>
        </td>
        <td>
          <span class="badge badge-info mr-1" *ngFor="let r of a.roles">{{ roleLabel(r) }}</span>
          <span class="text-muted" *ngIf="a.roles.length === 0">Aucun</span>
        </td>
        <td class="text-right text-nowrap">
          <button type="button" class="btn btn-sm btn-outline-secondary" (click)="openRoles(a)" *ngIf="a.type !== 'STUDENT'">
            <i class="fa fa-shield"></i> Rôles
          </button>
          <button type="button" class="btn btn-sm ml-1" *ngIf="canToggle(a)" (click)="toggleAccount(a)"
                  [ngClass]="a.enabled ? 'btn-outline-danger' : 'btn-outline-success'">
            <i class="fa" [ngClass]="a.enabled ? 'fa-ban' : 'fa-check'"></i> {{ a.enabled ? 'Désactiver' : 'Activer' }}
          </button>
          <!-- span : l'infobulle reste visible sur un bouton désactivé -->
          <span class="d-inline-block ml-1" [title]="editTitle(a)">
            <button type="button" class="btn btn-sm btn-outline-primary" (click)="openEdit(a)" [disabled]="!canEditAccount(a)">
              <i class="fa fa-pencil"></i> Modifier
            </button>
          </span>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
  <p class="text-muted small">
    <i class="fa fa-info-circle"></i> « Modifier » change le compte d'accès (identifiant, email, mot de passe) ; les autres
    informations d'un moniteur ou d'un élève se modifient depuis sa fiche.
    Un compte désactivé ne peut plus se connecter ; un moniteur désactivé est aussi retiré des plannings et de la liste des moniteurs.
    Les changements de rôles sont pris en compte à la prochaine connexion de l'utilisateur.
  </p>
</div>

<!-- Rôles d'un compte -->
<div class="modal fade" id="accountRolesModal" tabindex="-1" role="dialog" aria-labelledby="accountRolesLabel" aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="accountRolesLabel"><i class="fa fa-shield"></i> Rôles de {{ rolesAccount?.username }}</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
      </div>
      <div class="modal-body">
        <app-user-roles *ngIf="rolesAccount" [iEmail]="rolesAccount.email"></app-user-roles>
      </div>
    </div>
  </div>
</div>

<!-- Création / modification d'un compte du personnel -->
<div class="modal fade" id="staffAccountModal" tabindex="-1" role="dialog" aria-labelledby="staffAccountLabel" aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <form (ngSubmit)="save(f)" #f="ngForm" novalidate>
        <div class="modal-header">
          <h5 class="modal-title" id="staffAccountLabel">
            {{ editedId === null ? 'Nouveau compte' : 'Modifier le compte d\'accès' }}
          </h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
        </div>
        <div class="modal-body">
          <div class="alert alert-danger py-2" *ngIf="formError">{{ formError }}</div>

          <div class="form-group" *ngIf="editedId === null">
            <label for="accountType">Type de compte</label>
            <select id="accountType" name="accountType" class="form-control" [(ngModel)]="newType" (ngModelChange)="formError = ''">
              <option value="MONITOR">Moniteur (fiche moniteur + compte)</option>
              <option value="STAFF">Personnel (secrétariat...)</option>
            </select>
          </div>

          <!-- Fiche moniteur -->
          <fieldset *ngIf="editedId === null && newType === 'MONITOR'" class="monitor-fieldset">
            <legend class="monitor-fieldset__legend">Fiche moniteur</legend>
            <div class="form-group">
              <div class="form-check form-check-inline">
                <input class="form-check-input" type="radio" name="sexe" id="sexeM" value="M" [(ngModel)]="monitorForm.sexe">
                <label class="form-check-label" for="sexeM">Monsieur</label>
              </div>
              <div class="form-check form-check-inline">
                <input class="form-check-input" type="radio" name="sexe" id="sexeF" value="F" [(ngModel)]="monitorForm.sexe">
                <label class="form-check-label" for="sexeF">Madame</label>
              </div>
            </div>
            <div class="form-row">
              <div class="form-group col-sm-6">
                <label for="monitorLastname">Nom</label>
                <input id="monitorLastname" name="lastname" class="form-control" [(ngModel)]="monitorForm.lastname" required minlength="3" maxlength="50">
              </div>
              <div class="form-group col-sm-6">
                <label for="monitorFirstname">Prénom</label>
                <input id="monitorFirstname" name="firstname" class="form-control" [(ngModel)]="monitorForm.firstname" required minlength="3" maxlength="50">
              </div>
            </div>
            <div class="form-row">
              <div class="form-group col-8">
                <label for="monitorPhone">Téléphone</label>
                <input id="monitorPhone" name="phoneNumber" class="form-control" [(ngModel)]="monitorForm.phoneNumber"
                       required pattern="0[0-9]{9}" placeholder="0601020304">
              </div>
              <div class="form-group col-4">
                <label for="monitorColor">Couleur</label>
                <input id="monitorColor" name="color" type="color" class="form-control" [(ngModel)]="monitorForm.color">
              </div>
            </div>
          </fieldset>

          <div class="form-group">
            <label for="accountUsername">Nom d'utilisateur (connexion)</label>
            <input id="accountUsername" name="username" class="form-control" [(ngModel)]="form.username" required maxlength="20">
          </div>
          <div class="form-group">
            <label for="accountEmail">Email</label>
            <input id="accountEmail" name="email" type="email" class="form-control" [(ngModel)]="form.email" required email maxlength="50">
          </div>
          <div class="form-group">
            <label for="accountPassword">Mot de passe</label>
            <input id="accountPassword" name="password" type="password" class="form-control" autocomplete="new-password"
                   [(ngModel)]="form.password" [required]="editedId === null" minlength="6" maxlength="40"
                   [placeholder]="editedId === null ? '6 caractères minimum' : 'Laisser vide pour ne pas le changer'">
          </div>

          <div class="form-group mb-0" *ngIf="editedId === null">
            <label class="d-block">{{ newType === 'MONITOR' ? 'Rôles en plus du rôle Moniteur (facultatif)' : 'Rôles' }}</label>
            <div class="form-check form-check-inline" *ngFor="let role of staffRoles">
              <input class="form-check-input" type="checkbox" [id]="'role-' + role"
                     [checked]="form.roles?.includes(role)" (change)="toggleRole(role)">
              <label class="form-check-label" [for]="'role-' + role">{{ roleLabel(role) }}</label>
            </div>
          </div>
          <small class="d-block text-muted" *ngIf="editedId !== null && editedType !== 'STAFF'">
            <i class="fa fa-info-circle"></i> L'email de la fiche {{ editedType === 'MONITOR' ? 'moniteur' : 'élève' }} sera aussi mis à jour.
          </small>
          <small class="d-block text-muted" *ngIf="editedId !== null">Les rôles se gèrent avec le bouton « Rôles ».</small>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-dismiss="modal">Annuler</button>
          <button type="submit" class="btn btn-primary" [disabled]="saving">
            <span *ngIf="saving" class="spinner-border spinner-border-sm"></span> Enregistrer
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
